module.exports = "<div class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>{{ title }}</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <p>{{ content }}</p>\r\n    <a class=\"btn-blue mt15\" [routerLink]=\"['/subscribe']\" (click)=\"close()\">View Plans and Pricing</a>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/message/upgrade-message/upgrade-message.component.html
// module id = 916
// module chunks = 0